<template>
  <div class="careers">
    <div
      class="featured-container flex-l items-center-l relative overflow-hidden bg-near-white"
    >
      <div class="container pax20 tl-l w-100">
        <div class="w-40-l">
          <h1 class="f1-l">{{ $t('careers.heading') }}</h1>
          <p class="lh-copy">{{ $t('careers.subheading') }}</p>
        </div>
      </div>
      <div class="featured-image-container absolute-l top-0 right-0 w-60-l">
        <img
          data-src="~assets/images/careers-illustration.svg"
          class="featured-image lazyload"
        />
      </div>
    </div>
    <div class="container pax20 tl">
      <div class="bt bb b--light-silver pv4 ph2 flex flex-column flex-row-l">
        <div class="w-50-l">
          <p>{{ $t('careers.role') }}</p>
          <nuxt-link
            :to="localePath({ name: 'careers-onboarding-specialist' })"
            class="b f4 db fw5 black pv1"
            >Onboarding Specialist
            <span class="absolute ml2 f7 white bg-black">EN</span></nuxt-link
          >
        </div>
        <div class="w-25-l">
          <p>{{ $t('careers.team') }}</p>
          <p class="f4">Operations</p>
        </div>
        <div class="w-25-l">
          <p>{{ $t('careers.location') }}</p>
          <p class="f4">Vilnius</p>
        </div>
      </div>
      <div class="bt bb b--light-silver pv4 ph2 flex flex-column flex-row-l">
        <div class="w-50-l">
          <p>{{ $t('careers.role') }}</p>
          <nuxt-link
            :to="localePath({ name: 'careers-software-engineer-web-frontend' })"
            class="b f4 db fw5 black pv1"
            >Software Engineer - Web Frontend
            <span class="absolute ml2 f7 white bg-black">EN</span></nuxt-link
          >
        </div>
        <div class="w-25-l">
          <p>{{ $t('careers.team') }}</p>
          <p class="f4">Product</p>
        </div>
        <div class="w-25-l">
          <p>{{ $t('careers.location') }}</p>
          <p class="f4">Vilnius</p>
        </div>
      </div>
      <div class="bt bb b--light-silver pv4 ph2 flex flex-column flex-row-l">
        <div class="w-50-l">
          <p>{{ $t('careers.role') }}</p>
          <nuxt-link
            :to="localePath({ name: 'careers-marketing-project-manager' })"
            class="b f4 db fw5 black pv1"
            >Marketing Project Manager
            <span class="absolute ml2 f7 white bg-black">EN</span></nuxt-link
          >
        </div>
        <div class="w-25-l">
          <p>{{ $t('careers.team') }}</p>
          <p class="f4">Marketing</p>
        </div>
        <div class="w-25-l">
          <p>{{ $t('careers.location') }}</p>
          <p class="f4">Vilnius</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  scrollToTop: true,
};
</script>
